import { SVGProps, Ref, forwardRef } from 'react';

export const GhostOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2.8c-1.986-.02-3.982.571-5.43 1.977-1.275 1.239-2.105 3.055-2.225 5.315v.002L3.8 20.988c-.009.186.221.255.358.173l1.78-1.063a3.85 3.85 0 0 1 4.029.049L11.32 21c.413.26.947.26 1.36 0l1.353-.853a3.85 3.85 0 0 1 4.028-.05l1.782 1.064c.14.084.366.005.357-.173l-.544-10.894v-.002c-.12-2.26-.95-4.076-2.226-5.315C15.982 3.371 13.987 2.78 12 2.801M2.547 10C2.829 4.689 6.498.94 12 1c5.503-.06 9.171 3.688 9.453 8.998l.544 10.9c.08 1.6-1.687 2.638-3.078 1.808l-1.78-1.064a2.05 2.05 0 0 0-2.146.026l-1.352.853c-1 .631-2.281.631-3.281 0l-1.354-.853a2.05 2.05 0 0 0-2.145-.026l-1.78 1.064c-1.391.83-3.158-.208-3.078-1.809zM13.25 9.5c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75M9 7.75c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75S10.313 7.75 9 7.75"
                fill="currentColor"
            />
        </g>
    </svg>
));
GhostOutlinedSize24Glyph.displayName = 'GhostOutlinedSize24Glyph';
